import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDrawer2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDrawer2"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V19H18V22H16.5V19H7.5V22H6V19H3V3ZM4.5 11.75V17.5H11.25V11.75H4.5ZM11.25 10.25H4.5V4.5H11.25V10.25ZM15.5 9V13H14V9H15.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDrawer2;
